/**
 * Splash cover + first-screen readiness — App waits for `page_ready` before exit orchestration.
 */
type BoolListener = (value: boolean) => void;

let splash_covering = true;
let splash_page_ready = false;
const cover_listeners = new Set<BoolListener>();
const page_listeners = new Set<BoolListener>();

function emit(listeners: Set<BoolListener>, value: boolean): void {
  listeners.forEach(listener => {
    listener(value);
  });
}

export function getSplashCovering(): boolean {
  return splash_covering;
}

export function setSplashCovering(covering: boolean): void {
  if (splash_covering === covering) {
    return;
  }
  splash_covering = covering;
  emit(cover_listeners, covering);
}

export function subscribeSplashCovering(listener: BoolListener): () => void {
  cover_listeners.add(listener);
  return () => {
    cover_listeners.delete(listener);
  };
}

export function getSplashPageReady(): boolean {
  return splash_page_ready;
}

/** First route finished loading (banner media painted when present). */
export function setSplashPageReady(ready: boolean): void {
  if (splash_page_ready === ready) {
    return;
  }
  splash_page_ready = ready;
  emit(page_listeners, ready);
}

export function subscribeSplashPageReady(listener: BoolListener): () => void {
  page_listeners.add(listener);
  return () => {
    page_listeners.delete(listener);
  };
}

/** Call when splash mounts / cold start begins. */
export function resetSplashLaunchGate(): void {
  splash_covering = true;
  splash_page_ready = false;
  emit(cover_listeners, true);
  emit(page_listeners, false);
}
